import React from "react"

export {
  View as KeyboardAvoidingView,
  ScrollView as KeyboardAwareScrollView,
} from "react-native"

export function KeyboardProvider({ children }: { children: React.ReactNode }) {
  return children
}

export const KeyboardController = {
  dismiss: () => {},
}
